import React from "react";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/** A flat, foldable section head: number · label, one summary line, the chevron far right – a hairline, no card. */
export function SectionHead({ sfi, label, summary, done, open, onToggle, testId }) {
  return (
    <button type="button" onClick={onToggle} aria-expanded={open} className="group flex w-full items-center gap-4 rounded-[12px] px-3 py-3.5 text-left outline-none transition-colors hover:bg-black/[0.025] focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/30" data-testid={testId}>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2.5">
          {sfi != null ? <span className="font-mono text-[14px] text-muted-foreground">{sfi}</span> : null}
          {sfi != null ? <span className="text-muted-foreground/40">·</span> : null}
          <span className="text-[15px] font-semibold text-foreground">{label}</span>
        </div>
        <div className={cn("mt-1 flex items-center gap-1.5 text-[13px]", done ? "text-foreground/70" : "text-muted-foreground")}>{done ? <Check className="h-3.5 w-3.5 text-[hsl(var(--v-ok))]" strokeWidth={2.6} /> : null}{summary}</div>
      </div>
      <ChevronDown className={cn("h-4 w-4 shrink-0 text-muted-foreground/55 transition-transform duration-200", !open && "-rotate-90")} />
    </button>
  );
}
